import { Icon, IconProps } from './Icon';

export const LocationActiveIcon = ({ ...props }: IconProps) => (
  <Icon
    {...props}
    viewBox="0 0 28 28"
  >
    <defs>
      <linearGradient
        id="paint0_linear_5301_94069"
        x1="19.155"
        y1="4.91543"
        x2="-0.894088"
        y2="16.1472"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#15C3FF" />
        <stop
          offset="1"
          stopColor="#8DF4DB"
        />
      </linearGradient>
    </defs>
    <path
      d="M14.0023 1.81836C8.89137 1.81836 4.72754 6.00811 4.72754 11.162C4.72754 13.2523 5.44236 15.3157 6.72904 16.9555L14.0023 26.182L21.2756 16.9555C22.5623 15.3157 23.2771 13.2523 23.2771 11.162C23.2771 6.00811 19.1133 1.81836 14.0023 1.81836Z"
      fill="#C2E2FF"
    />
    <path
      d="M14.0023 1.81836C8.89137 1.81836 4.72754 6.00811 4.72754 11.162C4.72754 13.2523 5.44236 15.3157 6.72904 16.9555L14.0023 26.182L21.2756 16.9555C22.5623 15.3157 23.2771 13.2523 23.2771 11.162C23.2771 6.00811 19.1133 1.81836 14.0023 1.81836Z"
      fill="url(#paint0_linear_5301_94069)"
    />
    <path
      d="M14.1224 6.37793C14.5918 8.92594 16.5855 10.9196 19.1336 11.389C16.5855 11.8584 14.5918 13.8521 14.1224 16.4002C13.653 13.8521 11.6593 11.8584 9.11133 11.389C11.6593 10.9196 13.653 8.92594 14.1224 6.37793Z"
      fill="#FEFEFE"
    />
  </Icon>
);
